import apiClient, { type PagedResponse } from '../../client'
import type {
  ComponentCategoryItem,
  CreateComponentCategoryRequest,
  UpdateComponentCategoryRequest,
  GetComponentCategoriesParams,
} from '../../models/maestros.models'

const BASE_PATH = '/maestros/component-categories'

export const componentCategoriesService = {
  async getAll(params?: GetComponentCategoriesParams): Promise<PagedResponse<ComponentCategoryItem>> {
    return apiClient.get<PagedResponse<ComponentCategoryItem>>(BASE_PATH, params)
  },
  async getById(id: string): Promise<ComponentCategoryItem> {
    return apiClient.get<ComponentCategoryItem>(`${BASE_PATH}/${id}`)
  },
  async create(data: CreateComponentCategoryRequest): Promise<ComponentCategoryItem> {
    return apiClient.post<ComponentCategoryItem, CreateComponentCategoryRequest>(BASE_PATH, data)
  },
  async update(id: string, data: UpdateComponentCategoryRequest): Promise<ComponentCategoryItem> {
    return apiClient.put<ComponentCategoryItem, UpdateComponentCategoryRequest>(`${BASE_PATH}/${id}`, data)
  },
  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(`${BASE_PATH}/${id}`)
  },
}
